/* eslint-disable react/prop-types */
import React from 'react';
import { Field, FieldArray } from 'redux-form';

// Import components
import ModalWrapper from "../../../components/SchoolModals/ModalWrapper";
import LoadingOverlay from "../../../components/core/ui/LoadingOverlay";
import AsyncButton from "../../../components/core/button/AsyncButton";
import ClauseGroup from "../ClauseGroup";

// Import input components
import TextInput from "../../../components/core/input/TextInput";
import TextAreaInput from "../../../components/core/input/TextAreaInput";

// Import styles
import { _ModalBody, _ModalFooter, _ModalHeader } from "./style";
var ConditionsModal = function ConditionsModal(_ref) {
  var apiConditionResourcesAttributes = _ref.apiConditionResourcesAttributes,
    apiLoadedConditionTemplateId = _ref.apiLoadedConditionTemplateId,
    conditionModalVisible = _ref.conditionModalVisible,
    conditionResourcesOptions = _ref.conditionResourcesOptions,
    conditionsTemplateDirty = _ref.conditionsTemplateDirty,
    conditionTypeLabel = _ref.conditionTypeLabel,
    disabledUpdateCondition = _ref.disabledUpdateCondition,
    formSyncErrors = _ref.formSyncErrors,
    handleSubmit = _ref.handleSubmit,
    loadingStatus = _ref.loadingStatus,
    onToggleConditionModal = _ref.onToggleConditionModal,
    reduxFormSubmit = _ref.reduxFormSubmit,
    setLoading = _ref.setLoading,
    status = _ref.status;
  return /*#__PURE__*/React.createElement(ModalWrapper, {
    onRequestClose: onToggleConditionModal,
    overflow: "visible",
    padding: "0px",
    maxHeight: "100%",
    shouldCloseOnOverlayClick: false
  }, (status && status.apiLoadedConditionTemplate && status.apiLoadedConditionTemplate.isLoading || loadingStatus) && /*#__PURE__*/React.createElement(LoadingOverlay, null), /*#__PURE__*/React.createElement(_ModalHeader, null, conditionTypeLabel, " Condition Details", ' ', apiLoadedConditionTemplateId && "- #".concat(apiLoadedConditionTemplateId)), /*#__PURE__*/React.createElement(_ModalBody, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Field, {
    component: TextInput,
    labelText: "Title",
    name: "title",
    required: true,
    disabled: disabledUpdateCondition
  }), /*#__PURE__*/React.createElement(Field, {
    component: TextAreaInput,
    labelText: "Description",
    name: "description",
    required: true,
    disabled: disabledUpdateCondition
  }), /*#__PURE__*/React.createElement(FieldArray, {
    apiConditionResourcesAttributes: apiConditionResourcesAttributes,
    component: ClauseGroup,
    conditionResourcesOptions: conditionResourcesOptions,
    conditionModalVisible: conditionModalVisible,
    disabledUpdateCondition: disabledUpdateCondition,
    name: "condition_groups",
    rerenderOnEveryChange: true,
    setLoading: setLoading
  }))), /*#__PURE__*/React.createElement(_ModalFooter, null, /*#__PURE__*/React.createElement(AsyncButton, {
    disabled: formSyncErrors && formSyncErrors.disabledSave || !conditionsTemplateDirty || disabledUpdateCondition,
    onClick: reduxFormSubmit,
    buttonHeight: "40px",
    buttonWidth: "100px"
  }, apiLoadedConditionTemplateId ? 'Save' : 'Create')));
};
export default ConditionsModal;